{
    "NAME": "Langage de base de données",
    "Database_Section_MaintenanceInterval_Title": "Intervalle de maintenance de la base de données",
    "Database_Section_MaintenanceInterval_Description": "Configurez une période quotidienne pendant laquelle l'application suspend toute activité de base de données. Les heures de début et de fin sont exprimées en UTC.",
    "Database_Field_MaintenanceInterval_Enabled": "Suspension quotidienne de l'activité de la base de données",
    "Database_Field_MaintenanceInterval_TimeStart": "Heure de début (UTC)",
    "Database_Field_MaintenanceInterval_TimeEnd": "Heure de fin (UTC)",
    "Database_Field_MaintenanceInterval_DaysOfWeek": "Jours de la semaine",
    "Database_Day_Monday": "Lundi",
    "Database_Day_Tuesday": "Mardi",
    "Database_Day_Wednesday": "Mercredi",
    "Database_Day_Thursday": "Jeudi",
    "Database_Day_Friday": "Vendredi",
    "Database_Day_Saturday": "Samedi",
    "Database_Day_Sunday": "Dimanche",
    "Database_Action_Apply": "Appliquer",
    "Database_Action_Cancel": "Annuler",
    "Database_Action_Refresh": "Rafraîchir",
    "Database_Save_Success": "Paramètres de la base de données enregistrés.",
    "Database_Save_Error": "Impossible d'enregistrer les paramètres de la base de données.",
    "Database_Load_Error": "Impossible de charger les paramètres de la base de données.",
    "Database_Warning_ReadOnly": "Vous pouvez consulter ces paramètres, mais vous n'êtes pas autorisé à les modifier. Seuls les administrateurs système disposant d'un accès root peuvent modifier les paramètres de la base de données.",
    "Database_Warning_Unavailable": "Les paramètres de la base de données sont actuellement indisponibles. Il est possible que la base de données n'était pas accessible au démarrage de l'application."
}